import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import Dashboard from './components/Dashboard';
import Roadmap from './components/Roadmap';
import Features from './components/Features';
import CustomCursor from './components/CustomCursor';

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="min-h-screen bg-gray-900 text-white">
          <CustomCursor />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/dashboard/:walletAddress" element={<Dashboard />} />
            <Route path="/roadmap" element={<Roadmap />} />
            <Route path="/features" element={<Features />} />
          </Routes>
        </div>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
